import { render, staticRenderFns } from "./indexRoomStyle.vue?vue&type=template&id=60ffb03e&scoped=true"
import script from "./indexRoomStyle.vue?vue&type=script&lang=js"
export * from "./indexRoomStyle.vue?vue&type=script&lang=js"
import style0 from "./indexRoomStyle.vue?vue&type=style&index=0&id=60ffb03e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ffb03e",
  null
  
)

export default component.exports